// (CC, 2026-10-05) Event-block time label that follows the hour axis convention
// (friendlyCalendarHour: locale + hour12 default, lower-case am/pm in English)
// instead of friendlyCalendarTime's forced 24-hour "09:00".
import { getDateTimeDefaults, getI18nConfig } from "@v0y4ge/i18n-runtime";

export function calendarBlockTime(value: number): string {
  const hour = Math.floor(value);
  const minute = Math.round((value % 1) * 60);
  let locale = "en-US";
  try { locale = getI18nConfig().locale || "en-US"; } catch { /* default */ }
  let hour12: boolean | undefined;
  try { hour12 = getDateTimeDefaults().hour12; } catch { hour12 = undefined; }
  try {
    const out = new Intl.DateTimeFormat(locale, { hour: "numeric", minute: "2-digit", hour12, timeZone: "UTC" })
      .format(new Date(Date.UTC(2020, 0, 1, hour, minute)));
    return locale.toLowerCase().startsWith("en") ? out.replace(/AM|PM/g, (p) => p.toLowerCase()) : out;
  } catch {
    return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
  }
}
